import useUploadCSV from 'hooks/API/POST/useUploadCSV';
import useToaster from 'hooks/useToaster';
import { memo, useCallback, useEffect, useState } from 'react';
import { AiOutlineCloudUpload } from 'react-icons/ai';
import { getRandomUid } from 'utilities/uuid.service';

function AppCSVPicker({ accept, referenceKey, isPublic, handleChange, text, inputProps = {} }) {
  const headers = {
    'X-access-control': isPublic ? 'public' : 'private',
    'X-reference-key': referenceKey,
  };
  const [file, setFile] = useState(null);
  const [uploadedData, setUploadedData] = useState(null);
  const { isLoading, isError, mutateAsync } = useUploadCSV({ headers });

  useToaster(isLoading, { type: isError ? 'error' : 'success' });

  function handleFileChange(event) {
    if (isLoading) return;

    const file = event.target.files[0];

    setFile({ rawFile: file });

    event.target.value = null; // This is enable to select the same image again
  }

  const upload = useCallback(async () => {
    const formData = new FormData();
    formData.append('file', file.rawFile);

    const response = await mutateAsync(formData);

    setUploadedData(response?.data);
  }, [file?.rawFile, mutateAsync]);

  useEffect(() => {
    if (uploadedData?.file) {
      handleChange({
        file,
        meta: uploadedData,
      });
      setFile(null);
      setUploadedData(null);
    }
  }, [file, handleChange, uploadedData, uploadedData?.file]);

  useEffect(() => {
    if (file?.rawFile) {
      upload();
    }
  }, [file, upload]);

  const ID = getRandomUid();

  return (
    <>
      <label htmlFor={`#${ID}#`} className="btn-plane my-2">
        <span className="mx-2">
          <AiOutlineCloudUpload />
        </span>
        <span>{text}</span>
      </label>
      <input
        type="file"
        id={`#${ID}#`}
        style={{ display: 'none' }}
        accept={accept}
        onChange={handleFileChange}
        {...inputProps}
      />
    </>
  );
}

AppCSVPicker.defaultProps = {
  isPublic: false,
  text: 'Upload Excel',
  referenceKey: 'ES_LOGO',
  accept: '.csv',
  handleChange: () => {},
};

export default memo(AppCSVPicker);
